import { AbstractClientRequestContextBase } from "abweb/dto/generated/ds/AbstractClientRequestContextBase";
import { HistoricalPointInTime } from "abweb/dto/ds/HistoricalPointInTime";
export class AbstractClientRequestContext extends AbstractClientRequestContextBase {
  static createAbstractClientRequestContext() {
    const retVal = new AbstractClientRequestContext();
    retVal.initAbstractClientRequestContext(HistoricalPointInTime.createEmptyHistoricalPointInTime());
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=AbstractClientRequestContext.js.map
